import  React, { Component } from 'react';
import PropTypes from 'prop-types';


class Search extends Component {
  constructor(props) {
    super(props);
    
    this.handleChange = this.handleChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  handleChange(event) {
    this.props.setSearch(event.target.value);
  }
  
  handleClear(event) {
    this.props.clearState();
    this.props.requestRecords();
  }

  render() {
    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <input type="text" name="Search" className="search-bar" placeholder="Search..." onChange={this.handleChange} value={this.props.search}/>
        {this.props.search !== '' ?
          <p onClick={this.handleClear} style={{cursor: 'pointer', marginLeft: 5}}> Clear</p>
          : ''
        }
      </div>
    )
  }
}

Search.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  requestRecords: PropTypes.func.isRequired
};

export default Search;
